import type { ComponentType } from 'react';
import { useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { useFlag } from '../../services/launchDarkly';
import { formatValueWithK } from '../../utils/helpers';
import { useVwToPx } from '../EventTriggerDialog/hooks/useVwToPx';

import classes from './BaroulettaPopupImage.module.scss';

interface Props {
  imageUrl: string;
  coinIcon?: ComponentType<{ className?: string }>;
  amount?: number;
  coinType?: 'GC' | 'SC';
  type?: 'rounds' | 'coins';
  maxWidth?: string | number;
  showMaxPrize?: boolean;
}

export default function BaroulettaPopupImage({
  imageUrl,
  coinIcon: Coin,
  coinType,
  amount,
  type,
  maxWidth,
  showMaxPrize = false,
}: Props) {
  const parentRef = useRef<HTMLDivElement>(null);
  const fontSize = useVwToPx({ ref: parentRef, vwValue: 19 });
  const enableBaroullettaMaxPrizeOnPopup = useFlag('enable_barouletta_max_prize', false);
  const { t } = useTranslation();
  return (
    <div ref={parentRef} className={classes.baroulettaPopupWrapper} style={{ fontSize, maxWidth }}>
      <img alt="Barouletta Popup" className={classes.baroulettaPopupImage} src={imageUrl} />

      {/* undefined or 0 amount must hide coin and amount */}
      {showMaxPrize && !!amount && enableBaroullettaMaxPrizeOnPopup && (
        <div
          className={classes.baroulettaPopupText}
          style={{
            top: '56%',
          }}
        >
          {type === 'coins' && Coin && <Coin className={classes.baroulettaPopupCoinIcon} />}
          <span>
            {amount === Infinity ? (
              <>&nbsp;∞</>
            ) : coinType === 'GC' ? (
              formatValueWithK(amount, t)
            ) : (
              amount.toLocaleString()
            )}
          </span>
        </div>
      )}
    </div>
  );
}
